import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import routesData from "./routes";
import React from "react";
import { RedirectForService } from "@/components/auth-guard/auth-guard.component";

const Myroutes = () => {
  const history = createBrowserHistory();

  const getEnabledModules = () =>
  (process.env.REACT_APP_ENABLED_MODULES || "")
    .split(",")
    .map((m) => m.trim().toLowerCase());

const isModuleEnabled = (name) =>
  getEnabledModules().includes(name.toLowerCase());

  return (
    <Router history={history}>
      <Routes>
        {routesData
        .filter((route) => !route.module || isModuleEnabled(route.module))
        .map(
          ({ redirectToService, path, component, outlet, wrapper }, index) => {
            const WrapperComponent = wrapper ?? React.Fragment;
            return (
              <Route key={path} path={path} element={component}>
                {outlet && (
                  <Route
                    index
                    element={
                      redirectToService ? (
                        <RedirectForService path={path}>
                          <WrapperComponent>{outlet}</WrapperComponent>
                        </RedirectForService>
                      ) : (
                        <WrapperComponent>{outlet}</WrapperComponent>
                      )
                    }
                  />
                )}
              </Route>
            );
          }
        )}
        <Route path="*" element={<p>Not found</p>}></Route>
      </Routes>
    </Router>
  );
};

export default Myroutes;
